var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-fullscreen-icon-container"},[_c('img',{attrs:{"src":require("@/assets/Mobile_FullScreen_Button.svg"),"width":"16px"},on:{"click":_vm.onClickButton}})])}
var staticRenderFns = []

export { render, staticRenderFns }